export const index = function ({ dispatch, commit }, payload) {
  const data = {};

  data.url = "get_statistics";
  data.loading = "get_index";
  data.method = "GET";
  data.data = payload;
  return dispatch("axiosAdmin", data, { root: true })
    .then((response) => {
      commit("setIndex", response.data);
      return Promise.resolve(response);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
